'use strict';

var requestBuilder_buildRequestHeader = require('./requestBuilder/buildRequestHeader.js');
var responseInterceptors_ResponseInterceptorRequestService = require('./responseInterceptors/ResponseInterceptorRequestService.js');
var requestBuilder_buildUrlFromTemplate = require('./requestBuilder/buildUrlFromTemplate.js');
var requestBuilder_buildRequestFormData = require('./requestBuilder/buildRequestFormData.js');
var requestBuilder_buildRequestBody = require('./requestBuilder/buildRequestBody.js');
require('./requestBuilder/constants.js');
require('qs');

class RequestServiceBase extends responseInterceptors_ResponseInterceptorRequestService.ResponseInterceptorRequestService {
    constructor({ baseUrl, systemName }) {
        super();
        this.privateBaseUrl = '/';
        this.baseUrl = baseUrl !== null && baseUrl !== void 0 ? baseUrl : this.privateBaseUrl;
        this.version =
            (systemName && requestBuilder_buildRequestHeader.getCookieValue(`${systemName}-version`)) || undefined;
    }
    setDefaultHeaders(headers) {
        this.defaultHeaders = Object.assign({}, headers);
    }
    get baseUrl() {
        return this.privateBaseUrl;
    }
    set baseUrl(baseUrl) {
        this.privateBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
    }
    buildUrl(templateUrl, { queryParameters, bodyParameters } = {}) {
        return requestBuilder_buildUrlFromTemplate.buildUrlFromTemplate(`${this.baseUrl}${templateUrl}`, queryParameters, bodyParameters);
    }
    getHeaders(requestFormat) {
        return requestBuilder_buildRequestHeader.buildRequestHeader({
            version: this.version,
            defaultHeaders: this.defaultHeaders,
            requestFormat,
        });
    }
    normalizeData({ bodyParameters, format } = {}) {
        if (bodyParameters == null) {
            return undefined;
        }
        if (format === 'FormData') {
            return requestBuilder_buildRequestFormData.buildRequestFormData(bodyParameters);
        }
        return requestBuilder_buildRequestBody.buildRequestBody(bodyParameters);
    }
}

exports.RequestServiceBase = RequestServiceBase;
//# sourceMappingURL=RequestServiceBase.js.map
